import { render } from "./AdmissionsModal.vue?vue&type=template&id=6dfafd1c"
import script from "./AdmissionsModal.vue?vue&type=script&lang=js"
export * from "./AdmissionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__